<div class="template-field-details">

  <div class="details-grid" [formGroup]="detailsFormGroup">
    <sc-dictionary-field [model]="details.label" [defaultLabel]="'label'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-attribute.label'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 2;" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.key"></sc-dictionary-label>
      </mat-label>
      <input matInput name="key" formControlName="key" appPositiveInteger
        [required]="true" [maxLength]="255">
      </mat-form-field>
      <mat-checkbox name="required" formControlName="required" style="grid-column: 1; grid-row: 3;">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.required"></sc-dictionary-label>
      </mat-checkbox>
      <mat-form-field style="grid-column: 1; grid-row: 4;" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.mode"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="mode">
          @for (m of modeOptions; track m) {
            <mat-option value="{{m}}">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.mode.{{m}}"></sc-dictionary-label>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="grid-column: 1; grid-row: 5;" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.type"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="type">
          @for (t of typeOptions; track t) {
            <mat-option value="{{t}}">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.type.{{t}}"></sc-dictionary-label>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (showSelectDefinitionsSelection) {
        <mat-form-field style="grid-column: 1; grid-row: 6;" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.select-definition"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="selectDefinitionUuid">
            @for (s of templateDetails.selectDefinitions; track s) {
              <mat-option value="{{s.uuid}}">
                {{s.identifier}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (showDefaultValue) {
        <mat-form-field style="grid-column: 1; grid-row: 7;" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-attribute.default-value"></sc-dictionary-label>
          </mat-label>
          <input matInput name="defaultValue" formControlName="defaultValue"
            [required]="false" [maxLength]="255">
          </mat-form-field>
        }
        <div style="grid-column: 1; grid-row: 8;" class="align-right">
          <button mat-flat-button (click)="deleteField()">
            <sc-icon iconClass="fa-trash"></sc-icon>
          </button>
        </div>
      </div>

    </div>
